export default "__VITE_ASSET__gBoWR2t1J0zUGcwprkTnww__"